import { render, staticRenderFns } from "./FilePopup.vue?vue&type=template&id=2841e2f1&scoped=true&"
import script from "./FilePopup.vue?vue&type=script&lang=js&"
export * from "./FilePopup.vue?vue&type=script&lang=js&"
import style0 from "./FilePopup.vue?vue&type=style&index=0&id=2841e2f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2841e2f1",
  null
  
)

export default component.exports